'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of wellness
 */ const Wellness = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "51.8018",
                cy: "51.8018",
                r: "51.8018",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3792_5071)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M34.4765 82.797L37.6951 80.9389C39.1366 80.107 39.6302 78.2642 38.7982 76.8227L31.8592 64.8042C31.0273 63.3626 29.1845 62.8691 27.743 63.701L24.5245 65.5592C24.0225 65.8486 23.8519 66.4889 24.1414 66.9909L33.0448 82.4125C33.3342 82.9145 33.9746 83.0851 34.4765 82.7956V82.797Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M33.2038 64.0231L40.1429 76.0417C40.2701 76.2626 40.3791 76.4919 40.4672 76.7268C40.5903 77.0554 40.8993 77.2763 41.2488 77.3112C42.2387 77.4105 43.2216 77.623 44.1821 77.9516L48.3347 79.3763C50.8457 80.2376 53.5246 80.499 56.1546 80.1383C58.8432 79.7706 61.4046 78.7639 63.6249 77.2022L80.3706 65.4241C81.1984 64.8411 81.4822 63.7449 81.039 62.8333C79.9931 60.6815 77.3171 59.9042 75.2814 61.1597L63.6948 68.2987C60.9363 69.9989 57.7596 70.8979 54.5201 70.8979H48.8981C48.4325 70.8979 48.0257 70.5386 48.0117 70.073C47.9977 69.5906 48.3836 69.1963 48.8618 69.1963H53.0171C56.4929 69.1963 59.9114 68.3099 62.9482 66.6195L64.7742 65.6045C65.7012 65.0885 66.1011 63.9574 65.6872 62.9815C64.8469 60.9961 62.642 59.9713 60.5853 60.6046L56.8648 61.7483C56.0315 62.0042 55.1297 61.8937 54.3831 61.4435L52.3068 60.1908C50.0768 58.8458 47.5223 58.1355 44.9176 58.1355C42.173 58.1355 39.4871 58.9241 37.1788 60.4089L33.4876 62.7816C33.0738 63.0472 32.9549 63.5897 33.201 64.0148C33.2024 64.0175 33.2038 64.0203 33.2052 64.0231H33.2038Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip1_3792_5071)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                        cx: "53.1445",
                        cy: "38.7812",
                        rx: "11.686",
                        ry: "11.9255",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.7133 23.5237C44.4736 23.5237 37.7705 30.2268 37.7705 38.4665C37.7705 46.7062 44.4736 53.4093 52.7133 53.4093C60.953 53.4093 67.6561 46.7062 67.6561 38.4665C67.6561 30.2268 60.953 23.5237 52.7133 23.5237ZM62.2066 41.3637H55.6676V47.9574H49.7971V41.3637H43.22V35.5954H49.7971V28.9732H55.6676V35.5954H62.2066V41.3637Z",
                        fill: theme.ds5.asset[assetColor]["600"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3792_5071",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "57.2504",
                            height: "60.9387",
                            fill: "white",
                            transform: "translate(24 22)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3792_5071",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "29.8856",
                            height: "29.8856",
                            fill: "white",
                            transform: "translate(37.7676 23.5234)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.Wellness = Wellness;
//# sourceMappingURL=Wellness.cjs.map
